import { BadgeCheck } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const LicensingPage = lazyPage(() => import("./LicensingPage"), "LicensingPage");

export default defineModuleUi({
  key: "licensing",
  title: "Produtos SaaS",
  domain: "platform",
  icon: BadgeCheck,
  menu: [{ path: "/configuracoes/licencas", label: "Produtos SaaS", minRole: "manager", icon: BadgeCheck, order: 70, keywords: "licença plano cliente teste limite uso assinatura" }],
  routes: [{ path: "/configuracoes/licencas", element: <LicensingPage />, minRole: "manager" }],
});
